// Live Events types

// type StartEvent = {
//     type: 'start'
//     events: any
//     layer: number
// }

// type DataEvent = {
//     type: 'event'
//     layer: number
//     events: any[]
// }

// type FlowEvent = StartEvent | DataEvent


// // State types

// export type State = {
//     event: {
//         filters: Array<Filters>
//         timestamp: number
//     }
// }

// export interface Filters {
//     label: string
//     filter_name: string
//     value?: number
// }


// export default function(state: State , event: FlowEvent) {
//     switch (event.type) {
//         case 'event':
//             state.event = event.events[0]
//             return state
//         default:
//             return state
//     }
// }


const getInitialState = () => {
    return {
      value: {
          timestamp: 0
      },
    }
  }
  
  export const reducer = (state = getInitialState(), message) => {
    // test for initialState calls
    if (!message) {
      return state
    }
  
    if (message.baseline && message.type !== "event") {
      return state
    }
  
    switch (message.type) {
      case "start":
        return getInitialState()
  
      case "event":
        return {
          value: message.events[0]
        }
      default:
        return state
    }
  }
